module.exports = __webpack_public_path__ + "ECMv6/static/media/dualball68px.d79eb937.gif";